(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(scope){
scope.querySelectorAll('[data-bc-product-rail]').forEach(function(root){
if(root.dataset.bcReady)return;
root.dataset.bcReady='true';
var container=root.querySelector('.container');
function align(){
var rail=Array.from(root.querySelectorAll('.product-rail')).find(function(r){return r.getBoundingClientRect().width>0});
if(!rail)return;
var media=rail.querySelector('.product-card__media');
if(!media)return;
container.style.setProperty('--bc-arrow-top',(media.getBoundingClientRect().top-container.getBoundingClientRect().top)+'px');
container.style.setProperty('--bc-arrow-height',media.getBoundingClientRect().height+'px');
}
var observer=new ResizeObserver(align);
observer.observe(container);
root.querySelectorAll('.product-card__media').forEach(function(m){observer.observe(m)});
root.addEventListener('click',function(){requestAnimationFrame(align)});
root.querySelectorAll('.product-rail').forEach(function(rail){
var startX=0,startScroll=0,active=false,moved=false,pointer=null;
rail.addEventListener('pointerdown',function(e){
if(e.pointerType!=='mouse'||e.button!==0||e.target.closest('button,input,select,textarea'))return;
active=true;moved=false;pointer=e.pointerId;startX=e.clientX;startScroll=rail.scrollLeft;
});
rail.addEventListener('pointermove',function(e){
if(!active)return;
var dx=e.clientX-startX;
if(!moved&&Math.abs(dx)>6){moved=true;rail.classList.add('is-dragging');rail.setPointerCapture(pointer)}
if(moved){e.preventDefault();rail.scrollLeft=startScroll-dx}
});
function finish(){active=false;rail.classList.remove('is-dragging');if(pointer!==null&&rail.hasPointerCapture(pointer))rail.releasePointerCapture(pointer);pointer=null}
rail.addEventListener('pointerup',finish);
rail.addEventListener('pointercancel',function(){finish();moved=false});
rail.addEventListener('lostpointercapture',finish);
rail.addEventListener('pointerleave',function(){if(!moved)active=false});
rail.addEventListener('dragstart',function(e){e.preventDefault()});
rail.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopImmediatePropagation();moved=false}},true);
});
align();
});
}
init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-assistance"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    document.querySelectorAll('.product-assistance__form').forEach(function(form){
      if(form.dataset.supportReady)return;
      const email=form.querySelector('[name="contact[email]"]');
      const phone=form.querySelector('[name="contact[phone]"]');
      const whatsapp=form.querySelector('[data-support-whatsapp]');
      if(!email||!phone||!whatsapp)return;
      form.dataset.supportReady='1';form.noValidate=true;email.required=false;
      whatsapp.disabled=!whatsapp.dataset.number;
      const emailError=form.querySelector('[data-email-error]');
      const phoneError=form.querySelector('[data-phone-error]');
      function clear(field,error){field.removeAttribute('aria-invalid');error.hidden=true;}
      function validate(channel){
        clear(email,emailError);clear(phone,phoneError);
        email.required=channel==='email';phone.required=channel==='whatsapp';
        const field=channel==='email'?email:phone;
        const error=channel==='email'?emailError:phoneError;
        const digits=phone.value.replace(/\D/g,'');
        const ok=channel==='email'?(email.value.trim()!==''&&email.validity.valid):(digits.length>=10&&digits.length<=15);
        if(!ok){field.setAttribute('aria-invalid','true');error.hidden=false;field.focus();return false;}
        const common=[...form.querySelectorAll('input[required],textarea[required]')].filter(el=>el!==email&&el!==phone);
        return common.every(el=>el.reportValidity());
      }
      email.addEventListener('input',()=>clear(email,emailError));
      phone.addEventListener('input',()=>clear(phone,phoneError));
      form.addEventListener('submit',function(event){if(!validate('email'))event.preventDefault();});
      whatsapp.addEventListener('click',function(){
        if(!validate('whatsapp'))return;
        const value=name=>form.elements.namedItem(name).value.trim();
        const message=['Merhaba, WhatsApp desteği istiyorum.','Ad Soyad: '+value('contact[Ad]')+' '+value('contact[Soyad]'),'Telefon: '+phone.value.trim(),'Not: '+value('contact[body]'),'Ürün: '+value('contact[Ürün sayfası]')].join('\n');
        window.location.assign('https://wa.me/'+whatsapp.dataset.number+'?text='+encodeURIComponent(message));
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('product:section-replaced',function(){document.querySelectorAll('[data-assistance-product]').forEach(function(field){field.value=location.origin+location.pathname;});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function(){
  const key='bicicek.recent-products.v1';
  const lifetime=30*24*60*60*1000;
  let memory=[];
  let generation=0;
  function read(){
    try{const value=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(value)?value:[];}catch(e){return memory;}
  }
  function valid(item){return item&&typeof item.handle==='string'&&/^[a-z0-9][a-z0-9-]*$/.test(item.handle)&&Number.isFinite(item.at)&&Date.now()-item.at<lifetime;}
  async function update(){
    const section=document.querySelector('[data-recently-viewed]');
    if(!section)return;
    const match=location.pathname.match(/\/products\/([^/]+)/);
    if(!match)return;
    const handle=decodeURIComponent(match[1]);
    if(!/^[a-z0-9][a-z0-9-]*$/.test(handle))return;
    const run=++generation;
    const seen=new Set([handle]);
    const previous=read().filter(valid).filter(item=>{if(seen.has(item.handle))return false;seen.add(item.handle);return true;});
    memory=[{handle:handle,at:Date.now()},...previous].slice(0,21);
    try{localStorage.setItem(key,JSON.stringify(memory));}catch(e){}
    const limit=Math.min(20,Math.max(1,Number(section.dataset.limit)||20));
    const grid=section.querySelector('[data-recent-grid]');
    grid.replaceChildren();
    section.hidden=true;
    const cards=await Promise.all(previous.slice(0,limit).map(async item=>{
      try{
        const url=new URL(section.dataset.root+'products/'+encodeURIComponent(item.handle),location.origin);
        url.searchParams.set('section_id','recent-product-card');
        const response=await fetch(url,{credentials:'same-origin'});
        if(!response.ok)return null;
        const html=await response.text();
        const card=new DOMParser().parseFromString(html,'text/html').querySelector('[data-recent-product-card]');
        return card&&card.dataset.recentProductCard===item.handle?card:null;
      }catch(e){return null;}
    }));
    if(run!==generation||!section.isConnected)return;
    cards.filter(Boolean).forEach(card=>grid.appendChild(card));
    section.hidden=!grid.children.length;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',update);else update();
  document.addEventListener('product:section-replaced',update);
  document.addEventListener('shopify:section:load',update);
  window.addEventListener('pageshow',event=>{if(event.persisted)update();});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["similar-products"] && !Shopify.designMode) return;
  try {
    
(function(){
  let request=0;
  document.addEventListener('product:section-replaced',async()=>{
    const section=document.querySelector('[data-similar-products]');
    if(!section)return;
    const run=++request;
    section.hidden=true;
    try{
      const url=new URL(location.pathname,location.origin);url.searchParams.set('section_id',section.dataset.sectionId);
      const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)return;
      const replacement=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-similar-products]');
      if(run===request&&section.isConnected&&replacement)section.replaceWith(replacement);
    }catch(e){}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
